var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityTrainingDiaryNewEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#784ace;}.cls-2{fill:#d4bff6;}.cls-3{fill:#5735aa;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "activity_training_diary_new_entry"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 300.95,
    r: 299.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327.34,132.05v237.4a6.5,6.5,0,0,1-6.5,6.5H119.51V126a.46.46,0,0,1,.47-.46H320.84A6.5,6.5,0,0,1,327.34,132.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119.4,
    y: 125.56,
    width: 33.37,
    height: 250.39
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "245.07 191.49 268.99 171.56 292.91 191.49 292.91 125.88 245.07 125.88 245.07 191.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M370,524.47a58.33,58.33,0,0,1-58.26-58.26V419.05H263.34a56.8,56.8,0,1,1,0-113.6H311.7V258.37a58.26,58.26,0,0,1,116.52,0v47.08h56.16a56.8,56.8,0,0,1,0,113.6H428.22v47.16A58.33,58.33,0,0,1,370,524.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370,215.11a43.39,43.39,0,0,1,43.26,43.26v62.08h71.16a41.8,41.8,0,0,1,0,83.6H413.22v62.16A43.39,43.39,0,0,1,370,509.47h0a43.39,43.39,0,0,1-43.26-43.26V404.05H263.34a41.8,41.8,0,1,1,0-83.6H326.7V258.37A43.39,43.39,0,0,1,370,215.11h0m0-30a73.34,73.34,0,0,0-73.26,73.26v32.08H263.34a71.8,71.8,0,1,0,0,143.6H296.7v32.16a73.26,73.26,0,0,0,146.52,0V434.05h41.16a71.8,71.8,0,0,0,0-143.6H443.22V258.37A73.34,73.34,0,0,0,370,185.11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityTrainingDiaryNewEntry);
export default __webpack_public_path__ + "static/media/activity_training_diary_new_entry.edc3f6983f79c277ba48fc4ff499c28f.svg";
export { ForwardRef as ReactComponent };